import { useState, useContext } from "react";
import { useTranslation } from 'react-i18next';
import { Box, Typography, Link, TextField } from '@mui/material';
import { useTheme } from '@mui/material';
import { CardActions, Button } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { FormControlLabel, Radio, RadioGroup, } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { Spinner } from '/@/app/components/Spinner';
import { AppContext } from '/@/app/AppContext';
import { formatDate } from "/@/app/utils.jsx";
import { useApi} from '/@/app/Api';
import { InputAdornment } from '@mui/material';


export const PaidPlanActions = ({ plan, mode, PriceDetailsComponent }) => {
    const api=useApi();
    const { t } = useTranslation();
    const theme = useTheme();
const { bootstrapData } = useContext(AppContext);
const { featureEnabled } = useContext(AppContext);
const [paymentGateway, setPaymentGateway] = useState(bootstrapData.subscriptions.gateways[0]);

    if (!PriceDetailsComponent) {
        PriceDetailsComponent = () => <></>;
    }
    if (!mode) {
        // options are: 'automatic', 'priceWithDonationBox', 'donationBox'
        mode = 'automatic';
    }

    if (!plan.status) plan.status={};
    plan.status.payable=!plan.status.till || plan.status.prolongable;

    let price = "";
    if (plan.price === null) {
        price = "Бесплатно"
    } else {
        const currencies = ['RUB', 'USD', 'KGS'];
        for (let currency of currencies) {
            if (plan.price[currency]) {
                let digits = (plan.price[currency] / 100).toFixed(2);
                price = `${currency} ${digits}`;
                break;
            }
        }
    }

    const [submitStatus, setSubmitStatus] = useState(null);
    const [priceWithDonation, setPriceWithDonation] = useState(plan.price.RUB / 100 + 5000);  // FIXME magic number

    const pay = function (event, code=null)
    {
        let donation = 0;
        switch (mode) {
            case 'automatic':
                donation = 0;
                break;
            case 'priceWithDonationBox':
                donation = (parseInt(priceWithDonation) * 100 - plan.price.RUB) / 100;
                if (donation < 0) {
                    alert(`Оплата от ${(plan.price.RUB / 100).toFixed(0)} руб`);
                    return;
                }
                break;
            case 'donationBox':
                donation = 100000;  // FIXME magic number
                break;
            default:
                donation = 0;
        }
        //
        if (submitStatus) {
            return;  // prevent double tap
        }
        setSubmitStatus('payment');
        api.request('billing/payments/', {
                plan: plan.name,
                currency: 'RUB',
                donation_amount_cents: donation * 100,
		promocode:code,
		gateway:paymentGateway,
            },
	{
            method: 'POST',
        }).then(data => {
            location.href = data.payment_frontend_redirect;
        }).finally(function ()
	{
		setSubmitStatus(null);
	});
    };

	const [promocode, setPromocode] = useState('');
	const promocodeInfoClose = () => { setPromocodeInfo({open:false}); };
	const promocodeApply = () => { setPromocodeInfo({open:false}); pay(null, promocode);};
	const promocodeSkip = () => { setPromocodeInfo({open:false}); pay(null);};
	const [promocodeInfo,setPromocodeInfo]=useState({open:false})
	const promo_pay = () =>
	{
		if (submitStatus) return;

		setSubmitStatus('promocode');
		api.request('billing/promocode/'+promocode.trim(), {}, { method: 'GET',} )
		.then(re =>
		{
			setSubmitStatus(null);
			setPromocodeInfo(
			{
				open:true,
				title:re.status||'',
				desc:re.desc||'',
				action_text:re.state=='applicable'?t('Продолжить оплату с промокодом?'):t('Продолжить оплату без применения промокода?'),
				proceed_action:re.state=='applicable'?promocodeApply:promocodeSkip,
			});
		})
		.finally(function ()
		{
			setSubmitStatus(null);
		});
	};



    return (
        <CardActions sx={{
            flex: 1,
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'center',
            justifyContent: 'flex-end',
        }}>

	    <Dialog open={promocodeInfo.open} onClose={promocodeInfoClose}>
	    <DialogTitle>{promocodeInfo.title}</DialogTitle>
	    <DialogContent>
	    <Box sx={{mb:2}}><Typography sx={{fontSize:'1.2rem'}}>{promocodeInfo.desc}</Typography></Box>
	    <Box> <Typography variant="body1">{promocodeInfo.action_text}</Typography> </Box>
	    </DialogContent>
	    <DialogActions>
	    <Button onClick={promocodeInfoClose}>{t('Отмена')}</Button>
	    <Button onClick={promocodeInfo.proceed_action} variant="contained">{t('OK')}</Button>
	    </DialogActions>
	    </Dialog>

            {plan.status?.till &&
                <Typography variant="body1" sx={{
                    color: 'green',
                    textAlign: 'center',
                    mb: 1,
                }}>
                    <CheckCircleIcon sx={{
                        position: 'relative',
                        top: '0.3em',
                        mr: 1
                    }}/>{t(plan.status.prolongable?'Оплачен':'Продлён')+' '+t('до')+' '+formatDate(plan.status.till)}
                </Typography>
            }
	        {plan.status.payable &&
                <>
		    <PriceDetailsComponent plan={plan} />
                    {mode !== 'priceWithDonationBox' &&
                            <TextField
                                label="Промокод"
                                type="text"
                                sx={{ input: { textAlign: 'center' }, mb:2 }}
			        value={promocode}
                                onChange={ (e) => { setPromocode(e.target.value) }}
                            />
		    }
                    {mode === 'priceWithDonationBox' &&
                            <TextField
                                label="Сумма"
                                type="number"
                                defaultValue={priceWithDonation}
                                sx={{ input: { textAlign: 'right' } }}
                                onChange={ (e) => { setPriceWithDonation(e.target.value) }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">руб</InputAdornment>
                                    ),
                                }}
                                helperText={"от " + (plan.price.RUB / 100).toFixed(0) + " руб"}
                            />
		    }
		    {mode === 'donationBox' &&
			/* для примера */
			<>также пожертвовать 100 руб</>
		    }
		    {submitStatus ?
			<Box sx={{display: 'flex', flexFlow: 'column nowrap', alignItems: 'center'}}>
			    {submitStatus=='payment' && <Typography sx={{ mb: 1, color: theme.palette.primary.main }} variant="body2">переходим к оплате...</Typography>}
			    <Spinner size={40} />
			</Box>
			:
			<Box>
			<RadioGroup sx={{ml:2}} row value={paymentGateway} onChange={(e) => setPaymentGateway(e.target.value)} >
		            {bootstrapData.subscriptions.gateways.map((item) => (
				    <FormControlLabel key={item} value={item} control={<Radio />} label={ <Box> <Typography variant="body2"> {t(`payment-gateway-${item.substring(0, item.indexOf('-'))}`)} </Typography> <Typography variant="caption" color="text.secondary" > {t(`payment-gateway-${item.substring(0, item.indexOf('-'))}-desc`)} </Typography> </Box> } />
			    ))}
			</RadioGroup>
		        <Button onClick={promocode?promo_pay:pay}>
		            <CreditCardIcon sx={{ mr: 1}} /> {t(plan.status.prolongable?'продлить':'оплатить')}
		        </Button>
			</Box>
		    }
                </>
		}
            {plan.pending_payment_link &&
                <Box>
                    <Link
                        sx={{ fontWeight: "bold", color: "orange" }}
                        href={plan.pending_payment_link}
                    >Продолжить оплату со скидкой</Link>
                </Box>
            }
        </CardActions>
    );
}
